import { Trans } from 'react-i18next'
import { AppErrorType } from '@typesApp/AppError'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { ButtonLink } from '@components/foundation/button-link/ButtonLink'
import { SVGIcon } from '@components/foundation/svg-icon/SVGIcon'
import { ErrorActions } from './ErrorActions'
import styles from '../styles/ErrorContent.module.scss'

type ErrorContentProps = {
  message: string | string[] | undefined
  errorType?: AppErrorType
  ctaLabel?: string
}

export const ErrorContent: React.FC<ErrorContentProps> = ({ message, errorType, ctaLabel }) => {
  return (
    <div className={styles.body}>
      <SVGIcon library="base" name="clock" />
      <ErrorMessage message={message} errorType={errorType} />
      <ErrorActions ctaLabel={ctaLabel} />
    </div>
  )
}

type ErrorMessageProps = {
  message: string | string[] | undefined
  errorType?: AppErrorType
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, errorType }) => {
  const { t } = useAppTranslation()

  const isMultilineMessage = Array.isArray(message) && message.length > 1
  const keyForError =
    errorType && errorType !== AppErrorType.GENERIC_ERROR
      ? `error-page.body.message-${errorType}`
      : 'error-page.body.message'

  return (
    <>
      {!isMultilineMessage &&
        (message ?? (
          <Trans t={t} parent={'span'} i18nKey={keyForError}>
            <ButtonLink
              underline
              onClick={() => {
                window.location.href = `tel:${t('ContactInfo.phone')}`
              }}
            />
          </Trans>
        ))}
      {isMultilineMessage && (
        <div className={styles.multilineContent}>
          {message?.map(line => <span key={line.slice(0, 20)}>{line}</span>)}
        </div>
      )}
    </>
  )
}
